import { jsx as _jsx } from "react/jsx-runtime";
import { StarFilled, StarOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useToggleContentBlockerTemplateFavourite } from "../../../../../../hooks/content-blocker/useContentBlockerTemplateToggleFavourite.js";
import { useToggleServiceTemplateFavourite } from "../../../../../../hooks/service/useServiceTemplateToggleFavourite.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { useStores } from "../../../../../../store/root.js";
import { QueryKeys } from "../../../../../../util/query-keys.js";
const TemplateFavouriteToggle = ({ type, template, onFavouriteToggle })=>{
    const { t } = useTranslation();
    const { notificationStore, rcbAuthenticationStore } = useStores();
    const queryClient = useQueryClient();
    const [isFavourite, setIsFavourite] = useState(template.isFavourite);
    useEffect(()=>{
        setIsFavourite(template.isFavourite);
    }, [
        template
    ]);
    const [toggleServiceId, setToggleServiceId] = useState(undefined);
    const useToggleFavouriteService = useToggleServiceTemplateFavourite(toggleServiceId);
    useEffect(()=>{
        if (useToggleFavouriteService.isFetched && useToggleFavouriteService.isSuccess) {
            setToggleServiceId(undefined);
            setIsFavourite(useToggleFavouriteService.data.isFavourite);
        } else if (useToggleFavouriteService.isError && useToggleFavouriteService.error) {
            notificationStore.addFromServerError(useToggleFavouriteService.error, t);
        }
    }, [
        useToggleFavouriteService
    ]);
    const [toggleContentBlockerId, setToggleContentBlockerId] = useState(undefined);
    const useToggleFavouriteContentBlocker = useToggleContentBlockerTemplateFavourite(toggleContentBlockerId);
    useEffect(()=>{
        if (useToggleFavouriteContentBlocker.isFetched && useToggleFavouriteContentBlocker.isSuccess) {
            setToggleContentBlockerId(undefined);
            setIsFavourite(useToggleFavouriteContentBlocker.data.isFavourite);
        } else if (useToggleFavouriteContentBlocker.isError && useToggleFavouriteContentBlocker.error) {
            notificationStore.addFromServerError(useToggleFavouriteContentBlocker.error, t);
        }
    }, [
        useToggleFavouriteContentBlocker
    ]);
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: t("Switch favourite state for: {{name}}", {
            name: template.headline
        }),
        placement: "left",
        mouseEnterDelay: 1,
        children: /*#__PURE__*/ _jsx(Button, {
            disabled: !rcbAuthenticationStore.hasRole(EUserRole.Admin),
            type: "link",
            icon: isFavourite ? /*#__PURE__*/ _jsx(StarFilled, {
                style: {
                    color: "orange"
                }
            }) : /*#__PURE__*/ _jsx(StarOutlined, {}),
            onClick: ()=>{
                switch(type){
                    case "Content-Blocker":
                        queryClient.resetQueries(QueryKeys.toggleFavouriteContentBlocker(template.id));
                        setToggleContentBlockerId(template.id);
                        break;
                    case "Service":
                        queryClient.resetQueries(QueryKeys.toggleFavouriteService(template.id));
                        setToggleServiceId(template.id);
                        break;
                }
                onFavouriteToggle?.(template);
            }
        })
    });
};
export { TemplateFavouriteToggle };
